module.exports = __webpack_public_path__ + "static/media/img_Invoice2@3x.379758ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_Invoice2@3x.png
// module id = 951
// module chunks = 0